import { Typography, Box } from '@mui/material'
// import Grid2 from '@mui/material/Unstable_Grid2/Grid2'
import React from 'react'
import { Item } from './Item.js'
// import { VerticalAlignBottom } from '@mui/icons-material'
import { Colors } from '../styles/theme'
// const sxLabelGrid = {
//     display: 'flex',
//     justifyContent: {
//         xs: 'center',
//         md: 'flex-end',
//     },
//     // paddingRight: '20px',
//     alignSelf: 'center',
// }
// const sxLabelItem = {
//     // paddingRight: { md: 6 },
//     // paddingBottom: { xs: 0, md: 2 },
// }
const sxLabelTypography = {
    textAlign: {
        xs: 'center',
        md: 'right',
    },
    verticalAlign: 'bottom',
}

export default function LabelRow({ sxProp, children }) {
    return (
        <Box sx={{ display: 'inline-block' }}>
            <Item
                elevation={9}
                // @ts-ignore
                sx={{
                    ...sxProp,
                    border: `0.25px solid ${Colors.secondary}`,
                }}
            >
                <Typography variant="subtitle1" sx={sxLabelTypography}>
                    {children}
                </Typography>
            </Item>
        </Box>
    )
}
